import { staticFile } from "remotion";

/**
 * Resolve a media path to something the current runtime can fetch.
 *
 *   - "http(s)://…"  → already absolute, pass through (legacy behaviour).
 *   - "/api/…"       → server-relative URL. Used ONLY by the browser Studio
 *                      preview (@remotion/player), where assets are served by
 *                      the editor API instead of the bundle's public/ dir.
 *                      staticFile() would log a warning and re-encode it.
 *   - "data:…"       → inline data URL. Used ONLY by the onboarding design
 *                      studio, whose wizard holds not-yet-persisted uploads
 *                      (logo, brand font) as data URLs.
 *   - anything else  → a path under public/ (e.g. "clips/foo.mov"), resolved
 *                      via staticFile() exactly as the render pipeline always
 *                      has. The pipeline never passes leading-slash or data:
 *                      paths, so render output is byte-identical to before
 *                      this seam.
 */
export const resolveSrc = (src: string): string =>
  src.startsWith("http") || src.startsWith("/") || src.startsWith("data:") || src.startsWith("blob:")
    ? src
    : staticFile(src);
